//* Variables Imports
import { URL } from "../../../variables";

function CondicoesEspeciaisBox({ inscricao }) {
  const laudos = (inscricao.documentos || []).filter(
    (doc) => doc.tipoDocumento === "laudo_medico" && doc.arquivoCaminho
  );

  return (
    <div
      style={{
        marginTop: 12,
        background: "#fff7e6",
        border: "1px solid #ffe6b3",
        borderRadius: 8,
        padding: 12,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <div>
          <b style={{ color: "#1f2937" }}>
            Condições especiais para execução da prova: {" "}
          </b>
          <span>
            {inscricao.condicoesEspeciais &&
            String(inscricao.condicoesEspeciais).trim().length > 0
              ? inscricao.condicoesEspeciais
              : "Nenhuma"}
          </span>
        </div>
        {laudos.length > 0 && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {laudos.map((laudo, idx) => (
              <a
                key={`laudo-medico-${laudo.id ?? idx}`}
                href={`${laudo.arquivoCaminho}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-primary"
                style={{ color: "white" }}
              >
                {`Ver Laudo Médico${laudos.length > 1 ? ` ${idx + 1}` : ""}`}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CondicoesEspeciaisBox;